module.exports = __webpack_public_path__ + "static/media/light_pink-theme.26182186.png";